// src/utils/db.js
import { openDB } from 'idb';

export const DB_NAME = 'MyAppDB';
export const DB_VERSION = 5;                 // bump
export const STORES = ['sales', 'zakupy', 'clients', 'meta'];

export async function getDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      for (const name of STORES) {
        if (!db.objectStoreNames.contains(name)) {
          db.createObjectStore(name);
        }
      }
    },
  });
}

export async function dbGet(store, key) {
  try {
    const db = await getDB();
    return db.get(store, key);
  } catch (e) {
    console.warn(`[IDB] get ${store}/${key} failed`, e);
    return null;
  }
}

export async function dbPut(store, key, value) {
  try {
    const db = await getDB();
    return db.put(store, value, key);
  } catch (e) {
    console.warn(`[IDB] put ${store}/${key} failed`, e);
  }
}
